/**
 * The CRM contact form may not automatically anchor the page to the thank you or error
 * message after submission due to the position of the # fragment in the URL. This script
 * will check for the presence of the #thank-you or #error fragment and scroll the page
 * to the relevant message if found.
 */

(function ($) {

    $(function () {

        const url = window.location.hash;

        if (url.length > 1) {
            // The hash may contain a message as an additional param, e.g. #thank-you?message=success.
            // Let's extract the message if it exists.
            let maybeMessage = url.split('?')[1];

            setTimeout(function () {
                if (maybeMessage.length > 0) {
                    let message = maybeMessage.split('&message=')[1];

                    if (message.length > 1) {
                        // Decode the message.
                        message = decodeURIComponent(message);

                        // Update the message text.
                        if ($('#error').length > 0) {
                            $('#error').next('.alert').text(message);
                        }
                    }
                }
            }, 500);

            // The hash might have additional URL parameters starting with & or ?.
            // We only want the hash, so we'll split the string and take the first part.
            let hash = url.split(/&|\?/)[0];

            // Use a timeout to ensure the page has finished loading before scrolling.
            setTimeout(function () {
                if (hash === '#thank-you' || hash === '#error') {
                    $('html, body').animate({
                        scrollTop: $(hash).offset().top
                    }, 250);
                }
            }, 500);
        }

    });

})(jQuery);